export const CONFIG_FIELD_NUMBER_SMALL_SX = { width: '75px' }
export const CONFIG_FIELD_NUMBER_MEDIUM_SX = { width: '100px' }
export const CONFIG_FIELD_NUMBER_LONG_SX = { width: '220px' }
